import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import Loading from '../../components/Loading/Loading';
import UserForm from './UserForm';
import {Translate, I18n} from 'react-redux-i18n';
import helpers from '../../helpers';

import {
  fetchUser as fetchUserAction,
  clearUser as clearUserAction,
  setIsEdit as setIsEditAction,
  setError as setErrorAction,
  fetchCompanies as fetchCompaniesAction,
} from './UserActions';

function User(props) {
  const { loading, fetchUser, clearUser, setIsEdit, setError, fetchCompanies } = props;
  const { id } = useParams();

  useEffect(() => {
    setError({});

    if (id) {
      setIsEdit(true);
      fetchUser(id);
    } else {
      setIsEdit(false);
      clearUser();
    }

    const userLevel = helpers.getUserFromLocalStorage().level;

    if (userLevel === 'master') {
      fetchCompanies();
    }

    return () => {
      clearUser();
    };
  }, [id, fetchUser, clearUser, setIsEdit, setError, fetchCompanies]);

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <h3><strong><Translate value="user.title"/></strong></h3>
        <hr />
        <Translate value="user.desc"/>
        <div>
          <UserForm userId={id} />
        </div>
      </div>
    </div>
  );
}

User.propTypes = {
  loading: PropTypes.bool,
  fetchUser: PropTypes.func,
  clearUser: PropTypes.func,
  setIsEdit: PropTypes.func,
  setError: PropTypes.func,
  fetchCompanies: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.user.loading || state.user.loadingCompanies,
  errors: state.user.errors,
});

const mapDispatchToProps = {
  fetchUser: fetchUserAction,
  clearUser: clearUserAction,
  setIsEdit: setIsEditAction,
  setError: setErrorAction,
  fetchCompanies: fetchCompaniesAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(User);
